module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "Death_In_the_12th_House-5.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Death_In_the_12th_House3#Contents-A"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("To my agent Sandra Bond, with sincere gratitude for all your help and guidance. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("To Jessica Tribble, Annette Rogers, Robert Rosenwald, Barbara Peters, and all the wonderful people at Poisoned Pen Press: for your endless aid and support. And to Maryglenn McCombs for your so-appreciated tireless efforts and optimism. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("To Fiona Druckenmiller and Roberta Cary, for your unwavering friendship, faith, and stability. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("To my dear friends and family who have helped in so many ways: Ray Blumenfeld, Natalie Cagle, Anna Cody, Margaret Dorn, my mother Sidney Lewis, and my bother David Lewis. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("And to my brilliant editor and friend Carl Lennertz, whose constant clarity and wisdom continue to amaze me. Two down and many more to go!")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0cba68e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Death_In_the_12th_House-5.vue
// module id = 72
// module chunks = 0